import { render, staticRenderFns } from "./DouzaineProductQuantity.vue?vue&type=template&id=98e278da&"
import script from "./DouzaineProductQuantity.vue?vue&type=script&lang=js&"
export * from "./DouzaineProductQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports